import React from "react";
import { Box, Grid } from "@material-ui/core";
import PageTitleHeader from "components/Headers/PageTitleHeader";
import GenericButton from "components/Buttons/GenericButton";
import GenericDialog from "components/Dialogs/GenericDialogV2";
import FormInput from "components/FormFields/FormInput";
import { useForm } from "react-hook-form";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import useMessage from "hooks/useMessage";
import { cancelContractApproval } from "crud/contractApproval.crud";

const CancelRequestModal = ({ isOpenCancelModal, handleCloseCancelModal }) => {
  const queryClient = useQueryClient();
  const { id } = useParams();
  const { showSuccessMessage, showErrorMessage } = useMessage();

  const {
    handleSubmit,
    control,
    formState: { isSubmitting },
  } = useForm({
    defaultValues: {
      cancelationReason: "",
    },
  });

  const { mutateAsync } = useMutation(
    ["cancelContractApproval", id],
    (params) => cancelContractApproval(params),
    {
      onSuccess: () => {
        showSuccessMessage("Pedido de homologação de contratos cancelado com sucesso.", {
          okAction: async () => {
            await queryClient.invalidateQueries(["contractApprovalDetails", id]);
            await queryClient.invalidateQueries(["listContractApproval"]);
            handleCloseCancelModal();
          },
        });
      },
      onError: (error) => {
        let message = "Ocorreu um erro ao cancelar o pedido, por favor tente mais tarde.";
        if (error?.response?.data?.errors) {
          message = Object.values(error.response.data.errors).flat().join("\n");
        }
        showErrorMessage(message);
      },
    }
  );

  const onSubmit = async ({ cancelationReason }) => {
    await mutateAsync({
      requestNumber: id,
      cancelationReason: (cancelationReason ?? "").trim(),
    });
  };

  return (
    <GenericDialog open={isOpenCancelModal} onClose={handleCloseCancelModal} fullWidth maxWidth="md">
      <Box style={{ display: "flex", alignItems: "center", marginLeft: "-22px" }}>
        <PageTitleHeader title={"Cancelar Pedido de Homologação"} />
      </Box>

      <form id="cancel-contract-approval-form" onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <FormInput
              name="cancelationReason"
              label="Motivo de Cancelamento"
              placeholder="Descreva o motivo do cancelamento"
              control={control}
              required
              multiline
              rows={4}
              rules={{
                validate: {
                  requiredTrimmed: (value) => {
                    if (!value || value.trim().length === 0) return "Campo obrigatório";
                  },
                },
              }}
            />
          </Grid>

          <Grid
            item
            xs={12}
            style={{
              gap: "1rem",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <GenericButton typeSubmit={false} size="medium" color="tertiary" onClick={handleCloseCancelModal}>
              Fechar
            </GenericButton>
            <GenericButton loading={isSubmitting} typeSubmit size="medium" color="tertiaryRed">
              Confirmar Cancelamento
            </GenericButton>
          </Grid>
        </Grid>
      </form>
    </GenericDialog>
  );
};

export default CancelRequestModal;
